import React from 'react'
import Header from '../sharedFiles/header/header'

const LeadgerStatement = () => {
  return (
    <>
    <Header/>
    <div className='leadgerStatement'>leadgerStatement</div>
    </>
  )
}

export default LeadgerStatement